// extracted by mini-css-extract-plugin
export default {"root":"yumpgX2PLM","section":"oGu_doSWHm","section_wide":"WZzjSbfe6c","section_noPadding":"ozZnw38DMz","sectionHeader":"hEbIpQARji"};